var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHora = function SvgHora(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "hora_svg__Capa_2",
    viewBox: "0 0 20.74 20.74"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hora_svg__Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.37 5.19v5.52h3.56",
    fill: "none",
    stroke: "#22aa9e",
    strokeLinecap: "round",
    strokeWidth: "2px"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.37,
    cy: 10.37,
    r: 9.37,
    fill: "none",
    stroke: "#22aa9e",
    strokeLinecap: "round",
    strokeWidth: "2px"
  }))));
};
export default SvgHora;